module.exports = __webpack_public_path__ + "img/step2.737168a8.png";